// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"713b2a04b2d9add7","5405":"56f52f5a977458d1"}[chunkId] + ".css";
};